import { useEffect } from 'react'
import { Link, Redirect, useLocation } from 'react-router-dom'

import { Button, Spinner, SubMenu } from '../../components'
import { AddAccountPaths, Paths } from '../../config/routes'
import { useUser } from '../../contexts/user/user-context'
import { useAccounts } from '../../hooks/use-accounts'
import Step1 from './step1.icon'
import Step2 from './step2.icon'
import Step3 from './step3.icon'
export interface OnboardingProps {
    /** First name for header */
    firstName: string
}

export function Onboarding({ firstName }: OnboardingProps) {
    const location = useLocation()
    const { getUser, userProfile } = useUser()
    const { accounts, loading } = useAccounts({})

    useEffect(() => {
        getUser()
    }, [getUser])

    if (loading)
        return (
            <div className='flex flex-col items-center justify-center w-screen h-full'>
                <Spinner color='black' />
            </div>
        )

    if (accounts?.length) return <Redirect to={Paths.DASHBOARD} />

    return (
        <div className='container px-12 py-12 mx-auto'>
            <SubMenu
                options={[
                    {
                        children: 'Create identity',
                        selected: location.pathname.includes(Paths.ONBOARDING),
                        onClick: () => {},
                    },
                ]}
            />
            <div className='container py-10'>
                <h1 className='mb-2 text-5xl'>
                    Welcome to 🌽 Masa,{' '}
                    {
                        // @ts-ignore
                        userProfile?.getUserProfile?.firstName
                    }{' '}
                </h1>
                <h3 className='m-0'>
                    With Masa you can connect you financial accounts with the
                    DeFi apps you love to unlock the <br></br> best financial
                    products for you
                </h3>

                <div className='flex flex-row flex-wrap items-center justify-start mx-auto my-12 gap-x-32 gap-y-12'>
                    <div className='flex flex-col items-start max-w-xs text-left'>
                        <Step1 />
                        <h2 className='mt-4 text-3xl'>Step 1</h2>
                        <h3>
                            Connect your financial <br></br> accounts in just
                            seconds.
                        </h3>
                    </div>
                    <div className='flex flex-col items-start max-w-xs text-left'>
                        <Step2 />
                        <h2 className='mt-4 text-3xl'>Step 2</h2>
                        <h3>
                            We create your personal<br></br> financial identity
                        </h3>
                    </div>
                    <div className='flex flex-col items-start max-w-xs'>
                        <Step3 />
                        <h2 className='mt-4 text-3xl'>Step 3</h2>
                        <h3>
                            Unlock and access the <br></br> best financial
                            products
                        </h3>
                    </div>
                </div>
                <Link to={AddAccountPaths.ADD_BANK_ACCOUNT}>
                    <Button className='w-full py-4 mt-6 md:w-1/3'>
                        Get Started
                    </Button>
                </Link>
            </div>
        </div>
    )
}
